var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDollarSign = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8 0.666748L8 15.3334M11.3333 3.33341L6.33333 3.33341C5.71449 3.33341 5.121 3.57925 4.68342 4.01683C4.24583 4.45442 4 5.04791 4 5.66675C4 6.28559 4.24583 6.87908 4.68342 7.31666C5.121 7.75425 5.71449 8.00008 6.33333 8.00008H9.66667C10.2855 8.00008 10.879 8.24591 11.3166 8.6835C11.7542 9.12108 12 9.71458 12 10.3334C12 10.9523 11.7542 11.5457 11.3166 11.9833C10.879 12.4209 10.2855 12.6667 9.66667 12.6667L4 12.6667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollarSign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dollar-sign.f273adeb.svg";
export { ForwardRef as ReactComponent };